var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogout = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M15.25 16C15.25 15.5858 15.5858 15.25 16 15.25C16.4142 15.25 16.75 15.5858 16.75 16H15.25ZM16.75 8C16.75 8.41421 16.4142 8.75 16 8.75C15.5858 8.75 15.25 8.41421 15.25 8H16.75ZM12 2.75H7V1.25H12V2.75ZM3.75 6V18H2.25V6H3.75ZM7 21.25H12V22.75H7V21.25ZM15.25 18V16H16.75V18H15.25ZM15.25 8V6H16.75V8H15.25ZM12 21.25C13.7949 21.25 15.25 19.7949 15.25 18H16.75C16.75 20.6234 14.6234 22.75 12 22.75V21.25ZM3.75 18C3.75 19.7949 5.20507 21.25 7 21.25V22.75C4.37665 22.75 2.25 20.6234 2.25 18H3.75ZM7 2.75C5.20507 2.75 3.75 4.20507 3.75 6H2.25C2.25 3.37665 4.37665 1.25 7 1.25V2.75ZM12 1.25C14.6234 1.25 16.75 3.37665 16.75 6H15.25C15.25 4.20507 13.7949 2.75 12 2.75V1.25Z",
    stroke: "none",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15L21.2929 12.7071C21.6834 12.3166 21.6834 11.6834 21.2929 11.2929L19 9",
    fill: "none",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12L9 12",
    fill: "none",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogout);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logout.50bc91d2c26ed9ce4c9b1b1de0c65ca7.svg";